<template>
  <div class="my-10">
    <div class="flex flex-col sm:flex-row justify-between px-4 items-center">
      <h1 class="text-3xl font-bold text-center mb-4 sm:mb-0">{{ __('Dealerships') }}</h1>
      <div>
        <inertia-link :href="route('dealerships.create')" class="btn-primary">
          {{ __('Add dealership') }}
        </inertia-link>
      </div>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 overflow-scroll">
      <table class="w-full" v-if="dealerships.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __('Id') }}</th>
          <th class="p-4 text-left">{{ __('Name') }}</th>
          <th class="p-4 text-right w-24">{{ __('Actions') }}</th>
        </tr>

        <tr v-for="(dealership, index) in dealerships.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">{{ dealership.id }}</td>
          <td class="p-4">
            <inertia-link :href="route('dealerships.edit', {dealership: dealership.slug})" class="text-coral-400 hover:text-gray-500 font-semibold">
              {{ dealership.name }}
            </inertia-link>
          </td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('dealerships.edit', {dealership: dealership.slug})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>
              <button @click="destroy(dealership)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __('No dealerships at the moment...') }}
      </div>
    </div>

    <pagination :links="dealerships.meta.links"/>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import _ from 'lodash';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Dealerships'),
    };
  },
  props: {
    dealerships: Object,
  },
  components: {
    Layout,
    Icon,
    Pagination,
  },
  methods: {
    search: _.throttle(function () {
      this.$inertia.get(this.route('dealerships.index', { 'term': this.term }), {}, { replace: true });
    }, 150),
    destroy(dealership) {
      if (confirm(this.__('Are you sure you want to delete :name?', { name: dealership.name }))) {
        this.$inertia.delete(this.route('dealerships.destroy', { dealership: dealership.slug }));
      }
    },
  },
};
</script>
